export const areaPrices = {
    // 東京A
    "千代田区": 0,
    "中央区": 0,
    "港区": 0,
    "新宿区": 0,
    "文京区": 0,
    "台東区": 0,
    "墨田区": 0,
    "江東区": 0,
    "品川区": 0,
    "目黒区": 0,
    "大田区": 0,
    "世田谷区": 0,
    "渋谷区": 0,
    "中野区": 0,
    "杉並区": 0,
    "豊島区": 0,
    "北区": 0,
    "荒川区": 0,
    "板橋区": 0,
    "練馬区": 0,
    // 東京B
    "足立区": 2500,
    "葛飾区": 2500,
    "江戸川区": 2500,
    "武蔵野市": 2500,
    "三鷹市": 2500,
    "調布市": 2500,
    "狛江市": 2500,
    "西東京市": 2500,
    // 東京C
    "立川市": 5000,
    "府中市": 5000,
    "昭島市": 5000,
    "小金井市": 5000,
    "小平市": 5000,
    "日野市": 5000,
    "東村山市": 5000,
    "国分寺市": 5000,
    "国立市": 5000,
    "福生市": 5000,
    "東大和市": 5000,
    "清瀬市": 5000,
    "東久留米市": 5000,
    "武蔵村山市": 5000,
    "多摩市": 5000,
    "稲城市": 5000,
    // 東京D
    "八王子市": 7500,
    "青梅市": 7500,
    "町田市": 7500,
    "羽村市": 7500,
    "あきる野市": 7500,
    "瑞穂町": 7500,
    "日の出町": 7500,
    "檜原村": 7500,
    "奥多摩町": 7500,
    // 埼玉A
    "さいたま市中央区": 2500,
    "さいたま市桜区": 2500,
    "さいたま市浦和区": 2500,
    "さいたま市南区": 2500,
    "さいたま市緑区": 2500,
    "川口市": 2500,
    "草加市": 2500,
    "蕨市": 2500,
    "戸田市": 2500,
    "朝霞市": 2500,
    "志木市": 2500,
    "和光市": 2500,
    "新座市": 2500,
    // 埼玉B
    "さいたま市西区": 5000,
    "さいたま市北区": 5000,
    "さいたま市大宮区": 5000,
    "さいたま市見沼区": 5000,
    "さいたま市岩槻区": 5000,
    "川越市": 5000,
    "所沢市": 5000,
    "狭山市": 5000,
    "越谷市": 5000,
    "入間市": 5000,
    "八潮市": 5000,
    "富士見市": 5000,
    "三郷市": 5000,
    "吉川市": 5000,
    "ふじみ野市": 5000,
    "三芳町": 5000,
    "松伏町": 5000,
    // 埼玉C
    "飯能市": 7500,
    "東松山市": 7500,
    "春日部市": 7500,
    "上尾市": 7500,
    "桶川市": 7500,
    "北本市": 7500,
    "蓮田市": 7500,
    "坂戸市": 7500,
    "鶴ヶ島市": 7500,
    "日高市": 7500,
    "白岡市": 7500,
    "伊奈町": 7500,
    "毛呂山町": 7500,
    "越生町": 7500,
    "川島町": 7500,
    "吉見町": 7500,
    "鳩山町": 7500,
    "ときがわ町": 7500,
    "宮代町": 7500,
    "杉戸町": 7500,
    // 埼玉D
    "熊谷市": 10000,
    "行田市": 10000,
    "秩父市": 10000,
    "加須市": 10000,
    "本庄市": 10000,
    "羽生市": 10000,
    "鴻巣市": 10000,
    "深谷市": 10000,
    "久喜市": 10000,
    "幸手市": 10000,
    "滑川町": 10000,
    "嵐山町": 10000,
    "小川町": 10000,
    "横瀬町": 10000,
    "皆野町": 10000,
    "長瀞町": 10000,
    "小鹿野町": 10000,
    "東秩父村": 10000,
    "美里町": 10000,
    "神川町": 10000,
    "上里町": 10000,
    "寄居町": 10000,
    // 神奈川A
    "横浜市鶴見区": 2500,
    "横浜市神奈川区": 2500,
    "横浜市西区": 2500,
    "横浜市中区": 2500,
    "横浜市南区": 2500,
    "横浜市保土ケ谷区": 2500,
    "横浜市港北区": 2500,
    "横浜市旭区": 2500,
    "横浜市都筑区": 2500,
    "川崎市川崎区": 2500,
    "川崎市幸区": 2500,
    "川崎市中原区": 2500,
    "川崎市高津区": 2500,
    "川崎市多摩区": 2500,
    "川崎市宮前区": 2500,
    // 神奈川B
    "横浜市磯子区": 5000,
    "横浜市金沢区": 5000,
    "横浜市戸塚区": 5000,
    "横浜市港南区": 5000,
    "横浜市緑区": 5000,
    "横浜市瀬谷区": 5000,
    "横浜市栄区": 5000,
    "横浜市泉区": 5000,
    "横浜市青葉区": 5000,
    "川崎市麻生区": 5000,
    // 神奈川C
    "相模原市緑区": 7500,
    "相模原市中央区": 7500,
    "相模原市南区": 7500,
    "平塚市": 7500,
    "鎌倉市": 7500,
    "藤沢市": 7500,
    "厚木市": 7500,
    "大和市": 7500,
    "海老名市": 7500,
    "座間市": 7500,
    "綾瀬市": 7500,
    "寒川町": 7500,
    // 神奈川D
    "秦野市": 10000,
    "伊勢原市": 10000,
    "愛川町": 10000,
    "清川村": 10000,
    // 千葉A
    "千葉市花見川区": 5000,
    "千葉市美浜区": 5000,
    "市川市": 5000,
    "船橋市": 5000,
    "木更津市": 5000,
    "松戸市": 5000,
    "流山市": 5000,
    "鎌ケ谷市": 5000,
    "浦安市": 5000,
    // 千葉B
    "千葉市中央区": 7500,
    "千葉市稲毛区": 7500,
    "千葉市若葉区": 7500,
    "千葉市緑区": 7500,
    "野田市": 7500,
    "佐倉市": 7500,
    "柏市": 7500,
    "市原市": 7500,
    "八千代市": 7500,
    "我孫子市": 7500,
    "四街道市": 7500,
    "印西市": 7500,
    "白井市": 7500,
    // 千葉C
    "成田市": 10000,
    "八街市": 10000,
    "富里市": 10000,
    "酒々井町": 10000,
    "栄町": 10000,
};